export default function getMenuItemId(id, position) {
  return (id || '') + "-item-" + position;
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-bootstrap-typeahead/es/utils/getMenuItemId.js
// module id = 428
// module chunks = 31